import { render, staticRenderFns } from "./accountLog.vue?vue&type=template&id=63773e1a"
import script from "./accountLog.vue?vue&type=script&lang=ts"
export * from "./accountLog.vue?vue&type=script&lang=ts"
import style0 from "./accountLog.vue?vue&type=style&index=0&id=63773e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports